import {
  ApolloClient,
  InMemoryCache,
  createHttpLink,
  from,
  ApolloLink,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { GRAPHQL_ENDPOINT } from "./config";
import { getAdminToken, clearAdminToken } from "./auth";

const httpLink = createHttpLink({
  uri: GRAPHQL_ENDPOINT,
});

const authLink = setContext((_, { headers }) => {
  const token = getAdminToken();
  return {
    headers: {
      ...headers,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  };
});

// Catches GraphQL execution errors (thrown errors)
const errorLink = onError(({ graphQLErrors }) => {
  if (!graphQLErrors) return;
  const isUnauthorized = graphQLErrors.some(
    (err) => err.message === "Unauthorized" || err.message === "Not authorized",
  );
  if (isUnauthorized) handleUnauthorized();
});

// Catches "Unauthorized" inside data payload errors arrays
// e.g. { data: { adminUpsertBlog: { errors: ["Unauthorized"] } } }
const responseLink = new ApolloLink((operation, forward) => {
  return forward(operation).map((response) => {
    if (response?.data) {
      const hasUnauthorized = Object.values(response.data).some(
        (mutation: any) =>
          Array.isArray(mutation?.errors) &&
          mutation.errors.some(
            (e: string) => e === "Unauthorized" || e === "Not authorized",
          ),
      );
      if (hasUnauthorized) handleUnauthorized();
    }
    return response;
  });
});

function handleUnauthorized() {
  clearAdminToken();
  if (window.location.pathname.startsWith("/admin")) {
    window.location.href = "/admin/login";
  }
}

export const apolloClient = new ApolloClient({
  link: from([errorLink, responseLink, authLink.concat(httpLink)]),
  cache: new InMemoryCache(),
});
